<nb-layout [withScroll]=false>
    <nb-layout-header class="header" fixed>
        <div id="przss-head">
            <div class="przss-logo">
                <a href=""><img class="imge" src="/assets/images/prozess-web-logo02.png" alt="Header Logo"></a>
            </div>
            <div class="espacio"></div>
            <div class="logo-entidad">
                <img class="imge" [src]="logoEntidad$ | async" alt="LogoEntidad" />
            </div>
            <nb-actions>
                <nb-action id="test_1">
                </nb-action>
            </nb-actions>
        </div>
    </nb-layout-header>

    <nb-layout-header class="subheader" subheader>
        <div class="col-12" style="height: 30px;">
        </div>
    </nb-layout-header>

    <nb-layout-column>
        <router-outlet></router-outlet>
    </nb-layout-column>
</nb-layout>